import { render, staticRenderFns } from "./DeleteJobBtn.vue?vue&type=template&id=38a67bd6&scoped=true&"
import script from "./DeleteJobBtn.vue?vue&type=script&lang=js&"
export * from "./DeleteJobBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a67bd6",
  null
  
)

export default component.exports